import { inject, Injectable, signal } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Entity, Field } from '../model';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CustomService extends BaseService {
  activatedRoute = inject(ActivatedRoute);
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  callnetLanguageEnabled = signal<boolean>(false);

  // Custom code for callnet installation
  getPredefinedSearchFieldsForInsurancePolicy(
    allEntityAttributes: any[],
    entityToSearch: Entity
  ) {
    const indexServiceInsured = allEntityAttributes.findIndex(
      (x) => x.fld_code_ent === 'service_insured'
    );

    if (
      indexServiceInsured !== -1 &&
      allEntityAttributes[indexServiceInsured].value
    ) {
      const searchField = new Field();
      searchField.search_from = allEntityAttributes[indexServiceInsured].value;
      searchField.id =
        entityToSearch.fields.filter(
          (x) => x.fld_code === 'insurancepolicy_insured'
        )[0]?.id ?? 0;
      searchField.fld_code = 'singleEntity';
      return [searchField];
    }
    return [];
  }

  // Custom code for callnet installation
  getConnectedAccountEntdataIdForContact(
    item: any,
    allEntityAttributes: any[]
  ) {
    return allEntityAttributes.find(
      (x) => x.fld_code === 'singleEntity' && x.for_entity === 'account'
    )?.value;
  }

  checkIfCallnetLanguageIsEnabled() {
    if (
      ['localhost', 'dev.teamworkos.com', 'callnet.teamworkos.com'].includes(
        window.location.hostname
      )
    ) {
      this.callnetLanguageEnabled.set(true);
    }
  }
}
